module.exports = __webpack_public_path__ + "img/Academic-Info.7bdc171e.png";